/**
 * 数科-臻有钱首页-首页挽留弹窗 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称:数科-臻有钱首页-首页挽留弹窗
 * uuid:07b91a7c0e544f0681d42b56e5ae51f8
 */
import { closeWebView } from '@/api/native/utils';
import platform from '@/shared/utils/platform';
import { Vue, Component } from 'vue-property-decorator';
import wechat from '@/api/native/wechat';
import AdvCommonContainer from '../adv-common-container';

 @Component
export default class AdvHomeBackPopup extends Vue {
  private leaveHome() {
    if (platform.isHelloApp) {
      closeWebView();
    } else if (platform.isWechatMini) {
      wechat.navigateBack();
    } else {
      window.history.go(-2);
    }
  }

  private cancel() {
    this.leaveHome();
  }

  private onPopupNoShowHandler() {
    this.leaveHome();
  }

  private render() {
    return (
       <AdvCommonContainer
         advMasterId="07b91a7c0e544f0681d42b56e5ae51f8"
         onCancel={this.cancel.bind(this)}
         onNoDataLoad={() => this.onPopupNoShowHandler()}
         customVisibility="true"
       />
    );
  }
}
